import { $, $$ } from '@utils';
import removeAccentMarkAndUppercase from '@utils/RemoveAccentMarkAndUppercase';

let animationFrameGlp; // Store the animation frame ID
let animationTimeout; // Store the timeout ID for delaying the animation

function init() {
  if (!$('[data-au-autogas-calculator]')) return;

  addEventListeners();
}

function addEventListeners() {
  $$('[data-au-autogas-calculator-inputs] input').forEach((input) => {
    input.addEventListener('input', () => {
      // Cancel ongoing animation and recalculate
      if (animationFrameGlp) {
        cancelAnimationFrame(animationFrameGlp);
      }
      calculate();
    });
  });

  $$('[data-au-autogas-calculator-fuel-selector] [data-au-segmented-control]').forEach((input) => {
    input.addEventListener('click', () => {
      calculate();
    });
  });

  calculate();
  setupTogglePricesButton();
}

function updateCircleProgress(to) {
  const svg = $('[data-au-autogas-calculator-percentage]');
  const circle = $('[data-au-autogas-calculator-gradient-progress-circle]');
  const percentage = parseFloat(to) || parseFloat(svg.getAttribute('data-au-autogas-calculator-percentage'));
  // const percentageNum = $('[data-au-autogas-calculator-percentage-num]');
  const radius = 106;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - percentage / 100);
  const animationTime = 1; // in seconds

  // animate circle
  circle.style.transition = `stroke-dashoffset ${animationTime}s ease-in-out`;
  circle.style.strokeDashoffset = offset;
  // percentageNum.textContent = percentage.toFixed(2);
}

function animatePercentage(counterElement, from, to, duration) {
  let current = from;
  const frameRate = 24; // Frames per second
  const totalFrames = duration * frameRate;
  const increment = (to - from) / totalFrames;
  const circleTo = to > 0 ? to : 0;

  function updateCounter() {
    current += increment;

    if ((increment > 0 && current >= circleTo) || (increment < 0 && current <= circleTo)) {
      counterElement.innerText = circleTo.replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      return;
    }

    if (isNaN(current)) return;
    counterElement.innerText = Math.floor(current);
    animationFrameGlp = requestAnimationFrame(updateCounter);
  }

  // Cancel any ongoing animation
  if (animationFrameGlp) {
    cancelAnimationFrame(animationFrameGlp);
  }

  // Delay the animation to reduce flickering
  if (animationTimeout) {
    clearTimeout(animationTimeout);
  }

  animationTimeout = setTimeout(() => {
    // Circle animation
    updateCircleProgress(circleTo);

    if (to < 0) {
      counterElement.innerText = 0;
      return;
    }
    // Update counter if percentage is > 0
    updateCounter();
  }, 200); // Delay in milliseconds
}

function getGlpConsumption(fuelType, consumption, previousPrice, kmAnnual, pvpGlp) {
  const previousKmLiters = consumption / 100;
  let kmGlpLiters;

  switch (fuelType) {
    case 'gasolina':
      kmGlpLiters = previousKmLiters + 0.005;
      break;
    case 'gasoleo':
      kmGlpLiters = previousKmLiters + 0.01;
      break;
    default:
      throw new Error('Tipo inválido');
  }

  return kmGlpLiters * kmAnnual * pvpGlp;
}

function getPreviousPrice(fuelType) {
  const pvpGasoline = document.getElementById('pvp-gasolina');
  const pvpDiesel = document.getElementById('pvp-gasoleo');
  let finalImport;

  switch (fuelType) {
    case 'gasolina':
      finalImport = txtToFloat(pvpGasoline.value);
      break;
    case 'gasoleo':
      finalImport = txtToFloat(pvpDiesel.value);
      break;
    default:
      throw new Error('Tipo inválido');
  }

  return finalImport;
}

function getFuelType() {
  const activeInput = $('[data-au-autogas-calculator-fuel-selector] input:checked');
  return activeInput ? activeInput.id : null;
}

function setAnnualSaving(value) {
  if (value > 0) {
    $('[data-au-autogas-calculator-output-saving-euros-year]').textContent = value
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  } else {
    $('[data-au-autogas-calculator-output-saving-euros-year]').textContent = 0;
  }
}

function setMonthSaving(value) {
  if (value > 0) {
    $('[data-au-autogas-calculator-output-saving-euros-month]').textContent = value
      .toFixed(2)
      .replace('.', ',')
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  } else {
    $('[data-au-autogas-calculator-output-saving-euros-month]').textContent = 0;
  }
}

function txtToFloat(txt) {
  return parseFloat(txt.toString().replace(',', '.'));
}

function calculate() {
  const counterElement = $('[data-au-autogas-calculator-percentage-num]');
  const pvpGlp = txtToFloat(document.getElementById('pvp-glp').value);
  const numberVehicles = txtToFloat(document.getElementById('vehicles-number').value);
  const numberVehiclesText = $('[data-au-autogas-calculator-output-saving-vehicle]');
  const consumption = txtToFloat(document.getElementById('consumption').value);
  const consumptionText = $('[data-au-autogas-calculator-output-saving-liters]');
  const kmAnnual = txtToFloat(document.getElementById('kilometers').value);
  const kmAnnualText = $('[data-au-autogas-calculator-output-saving-km]');
  const fuelType = getFuelType();
  const previousPrice = getPreviousPrice(fuelType);
  const glpConsumption = getGlpConsumption(fuelType, consumption, previousPrice, kmAnnual, pvpGlp);
  const totalPreviousConsumption = (consumption / 100) * kmAnnual * previousPrice;
  const totalGlpConsumption = totalPreviousConsumption * numberVehicles;
  const annualSaving = (totalPreviousConsumption - glpConsumption) * numberVehicles;
  const percentSaving = ((annualSaving * 100) / totalGlpConsumption).toFixed(2);

  if (!isNaN(annualSaving)) {
    setAnnualSaving(annualSaving);
    setMonthSaving(annualSaving / 12);
  }
  if (!isNaN(percentSaving)) {
    animatePercentage(counterElement, 0, percentSaving, 1);
  }

  // set texts on the results block
  numberVehiclesText.textContent = numberVehicles;
  consumptionText.textContent = consumption;
  kmAnnualText.textContent = kmAnnual.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}

function setupTogglePricesButton() {
  const toggleButton = $('[data-au-autogas-calculator-toggle-prices]');
  const priceInputs = $$('[data-au-autogas-calculator-price-input] input');
  const priceWrappers = $$('[data-au-autogas-calculator-prices-wrapper]');
  if (!toggleButton) return;

  toggleButton.addEventListener('click', () => {
    const [text1, text2] = toggleButton.getAttribute('data-au-autogas-calculator-toggle-prices').split('/');
    const currentText = toggleButton.querySelector(':not([data-au-icon])').textContent.trim();
    const newText = currentText === text1 ? text2 : text1;
    const icon = toggleButton.querySelector('[data-au-icon]');
    const item_id = `${removeAccentMarkAndUppercase(getFuelType())}_${removeAccentMarkAndUppercase(currentText)}`;

    // Toggle button text
    toggleButton.querySelector(':not([data-au-icon])').textContent = newText;

    // Toggle button icon
    if (icon) {
      icon.textContent = icon.textContent === 'edit' ? 'check_circle' : 'edit';
    }

    // Toggle prices wrapper visibility
    priceWrappers.forEach((wrapper) => {
      if (wrapper.classList.contains('au-hide')) {
        wrapper.classList.remove('au-hide');
      } else {
        wrapper.classList.add('au-hide');
      }
    });

    // Update price text when inputs change
    priceInputs.forEach((input, index) => {
      input.addEventListener('input', () => {
        const priceElements = input
          .closest('[data-au-autogas-calculator-prices]')
          .querySelectorAll('[data-au-autogas-calculator-price]');

        priceElements[index].textContent = input.value.replace('.', ',');
      });
    });

    // datalayer
    window.dataLayer.push({
      event: 'navigation',
      content_type: 'clickEnlace',
      item_id,
    });
  });
}

export default { init };
